<template>
    <div>
        <div class='heading-text-container'>
                <img class='lock-it-in-icon' src="/images/lock_it_in/lock_it_in_icon.svg"/>
                <div class='lock-it-in-text'>Lock it in</div>
                <div class='favourite-wine-text'>Your favourite wine at our best price, <span class='italic'>always.</span></div>
        </div>
        <div class='banner'>
                <div class='banner-text-container'>
                <div><i class="fa-light fa-play-pause banner-icon"></i></div>
                <div class='banner-text'>You're in control - Manage your subscription online, skip a case or cancel anytime</div>
                </div>
            <div class='banner-text-container'>
                <div><i class="fa-light fa-money-bill-transfer banner-icon"></i></div>
                <div class='banner-text'>No quibble guarantee - If you don't enjoy one of our wines, we'll recommend a replacement or give you your money back</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

.heading-text-container{
    display: flex;
    justify-content: center;
    gap: 30px;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    margin-bottom: 24px;
}

.lock-it-in-text{
    font-size: 2.2rem;
    font-weight: 600;
    color: var(--maj-dark-green);
    text-transform: uppercase;
}

.favourite-wine-text{
    color: var(--maj-slate);
    font-size: 1.8rem;
    font-family: Garamond;
    font-weight: 600;
}

.italic{
    font-style: italic;
     font-family: Garamond;
}

.banner{
    background-color: var(--maj-slate);
    width: 100%;
    min-height: 52px;
    color: white;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 2rem;
    box-sizing: border-box;
    gap: 32px;

    @media(max-width: 1000px){
        flex-direction: column;
        gap: 12px;
        padding: 18px 20px;
    }
}

.banner-icon{
    font-size: 1.8rem;
}

.banner-text-container{
    display: flex;
    gap: 10px;
    align-items: center;

    @media(max-width: 1000px){
        max-width: 700px;
    }
}

.banner-text{
    @media(max-width: 1000px){
        max-width: 300px;
    }
    // word-break: break-all;
}

.lock-it-in-icon{
    height: 44px;
    margin-right: -20px;
}

</style>